import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { fetchVaultQuestionById } from "../../redux/vaultQuestions/vaultQuestionThunks";
import { formatAction } from "../../utils/formatAction";
import moment from "moment";
import { MemberQuestionInfo } from "./AskedBy";
import { CompleteStatusField, DealtLine } from "./CompleteStatus";
import { isComplete } from "./memberQuestionUtils";
import QuestionStats from "./QuestionStats";

const ViewVaultQuestionsPageNew = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { questionData, loading, error } = useSelector(
    (state) => state.vaultQuestion
  );

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("question-info");
  // The Stats tab (founder 2026-11-04): every Daily Question, bank or
  // member. Its numbers load on the first click, never with the page.
  const [statsOpened, setStatsOpened] = useState(false);
  const openStats = () => {
    setActiveTab("stats");
    setStatsOpened(true);
  };
  // Another question on the same page starts on its Info again.
  useEffect(() => {
    setActiveTab("question-info");
    setStatsOpened(false);
  }, [id]);

  useEffect(() => {
    if (id) {
      dispatch(fetchVaultQuestionById({ id, navigate }));
    }
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (error) {
      setErrorMessage(error);
      setTimeout(() => setErrorMessage(""), 3000);
    }
  }, [error]);

  // Helper: generate a pastel-ish color from a string
  const getTagColor = (tag) => {
    let hash = 0;
    for (let i = 0; i < tag.length; i++) {
      hash = tag.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 80%)`; // pastel colors
  };

  if (loading) return <Loader />;

  const hasStats = questionData?.tier === "dailyQuestion";

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {/* Alerts */}
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {/* Tabs */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "question-info" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("question-info")}
                  type="button"
                  role="tab"
                >
                  Question Info
                </button>
              </li>
              {hasStats && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link d-flex align-items-center px-24 ${activeTab === "stats" ? "active" : ""
                      }`}
                    onClick={openStats}
                    type="button"
                    role="tab"
                  >
                    Stats
                  </button>
                </li>
              )}
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {/* Question Info */}
              <div
                className={`tab-pane fade ${activeTab === "question-info" ? "show active" : ""
                  }`}
                role="tabpanel"
              >
                <div className="row">
                  {/* A member question: labelled rows, who asked it, for
                      which city, when it was asked, approved and shown, and
                      how many answered (2026-11-03, rows 2026-11-04).
                      Nothing on a bank question. */}
                  <MemberQuestionInfo item={questionData} onSeeStats={hasStats ? openStats : undefined} />
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Tier:</label>
                    <div>{questionData?.tier || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Question Type:</label>
                    <div>{formatAction(questionData?.questionType || "N/A")}</div>

                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Question: </label>
                    <div>{questionData?.questionText || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Status:</label>
                    {/* A member question shown to its city is Complete
                        (2026-11-04, memberQuestionUtils SHOWN ONCE). */}
                    {isComplete(questionData) ? (
                      <div>
                        <CompleteStatusField item={questionData} />
                      </div>
                    ) : (
                      <>
                        <div>{questionData?.isActive ? "Active" : "Inactive"}</div>
                        <DealtLine item={questionData} />
                      </>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">
                      AI Review Status:
                    </label>
                    <div>{questionData?.reviewStatus}</div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">
                      Published Status:
                    </label>
                    <div>
                      {questionData?.isPublished ? (
                        <span >Published</span>
                      ) : (
                        <span >
                          Not Published
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Created At */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Created At:</label>
                    <div>
                      {questionData?.createdAt
                        ? moment(questionData.createdAt).format("DD-MM-YYYY, hh:mm A")
                        : "N/A"}
                    </div>
                  </div>

                  {/* Updated At */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Updated At:</label>
                    <div>
                      {questionData?.updatedAt
                        ? moment(questionData.updatedAt).format("DD-MM-YYYY, hh:mm A")
                        : "N/A"}
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Tags:</label>
                    <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
                      {Array.isArray(questionData?.tags) &&
                        questionData.tags.length > 0 ? (
                        questionData.tags.map((tag, idx) => (
                          <span
                            key={idx}
                            className="badge"
                            style={{
                              backgroundColor: getTagColor(tag),
                              color: "#333",
                              padding: "4px 8px",
                            }}
                          >
                            {tag}
                          </span>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Answers:</label>
                    {questionData?.answers?.filter(
                      (ans) => ans && ans.trim() !== ""
                    ).length > 0 ? (
                      <ul
                        className="mb-0 ps-3"
                        style={{ listStyleType: "disc" }}
                      >
                        {questionData.answers
                          .filter((ans) => ans && ans.trim() !== "")
                          .map((ans, index) => (
                            <li key={index}>{ans}</li>
                          ))}
                      </ul>
                    ) : (
                      <div className="text-muted">N/A</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Stats: mounted on the first click, then kept. */}
              {hasStats && statsOpened && (
                <div
                  className={`tab-pane fade ${activeTab === "stats" ? "show active" : ""
                    }`}
                  role="tabpanel"
                >
                  <QuestionStats key={id} questionId={id} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVaultQuestionsPageNew;
